'use client';

import { useTranslations } from 'next-intl';
import { useTenantStore } from '@/stores/tenant-store';

interface GiftAidSectionProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Pre-formatted Gift Aid boost amount (25% of donation, e.g. "£25") */
  amount: string;
}

export function GiftAidSection({ checked, onChange, amount }: GiftAidSectionProps) {
  const tForm = useTranslations('donate.form');
  const charityName = useTenantStore((s) => s.name) || 'the charity';

  return (
    <div className="bg-stone-800/50 rounded-lg p-4 border border-stone-700">
      <label
        htmlFor="modal-donation-gift-aid"
        className="flex items-start gap-2.5 text-white text-sm font-medium cursor-pointer"
      >
        <input
          type="checkbox"
          id="modal-donation-gift-aid"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="rounded border-stone-600 bg-stone-800 text-[#c5b358] focus:ring-[#c5b358] w-4 h-4 mt-0.5 flex-shrink-0"
        />
        <span>{tForm('giftAidToggle', { charityName, amount })}</span>
      </label>

      {checked && (
        <div className="mt-3 ml-6.5 space-y-2">
          <p className="text-stone-400 text-xs leading-relaxed">{tForm('giftAidByTicking')}</p>
          <ul className="text-stone-400 text-xs leading-relaxed list-disc pl-4 space-y-1.5">
            <li>{tForm('giftAidBullet1', { charityName })}</li>
            <li>{tForm('giftAidBullet2')}</li>
            <li>{tForm('giftAidBullet3')}</li>
          </ul>
        </div>
      )}
    </div>
  );
}
